
import Vue from 'vue';
import { mapState } from 'vuex';
import { auth } from '@/firebase';

export default Vue.extend({
	name: 'UserNotActivated',
	metaInfo: {
		title: 'Account Deactivated | RunDiffusion',
	},
	data () {
		return {
			signingOut: false,
		};
	},
	computed: {
		...mapState([
			'user',
		]),
	},
	methods: {
		async onSignOut () {
			this.signingOut = true;
			try {
				await auth.signOut();
			} catch (e) {
				console.error('Failed to sign out:', e);
			}
			window.location.assign('/login');
		},
	},
});
